import { ChangeEvent, FC } from 'react'
import { Box, Checkbox, Typography } from '@mui/material'
import { tooltipClasses } from '@mui/material/Tooltip'
import theme from 'theme'

/* Utils */
import { CPIManifest, IntegrationInstance, IntegrationStatusMessage } from 'models'
import { getIntegrationLogoFromManifest } from '../../../utils/libraryDetailsUtils'
import { Checked } from '../../../CPIDetails'

/* Components */
import { IntegrationInstanceCard, IntegrationTextItem } from './dataSourceCard.styles'
import { InstanceCheckedIcon, InstanceUncheckedIcon } from 'ui/components/svg'
import { InstanceTooltip } from '../InstanceTooltip'
import DataSourceErrorTooltip from 'ui/components/data-source-error-tooltip'
import ArrowUpTooltip from 'ui/components/svg/ArrowUpTooltip'

interface Props {
  integration: IntegrationInstance
  manifestData: CPIManifest | null
  checked: Checked
  changeHandler: (e: ChangeEvent<HTMLInputElement>, integration: IntegrationInstance) => void
}

const DataSourceCard: FC<Props> = ({ integration, manifestData, checked, changeHandler }) => {
  return (
    <IntegrationInstanceCard
      className="integration-instance-card"
      isFailed={integration.syncStatus && integration.syncStatus.status === IntegrationStatusMessage.failed}
    >
      {integration.syncStatus && integration.syncStatus.status === IntegrationStatusMessage.failed ? (
        <DataSourceErrorTooltip
          key={integration.id}
          logoPath={getIntegrationLogoFromManifest(integration.integration_name, manifestData).replace(
            '/icons/rounded/',
            ''
          )}
          instanceName={integration.is_v2 ? integration.name || '' : integration.name}
          logoSize={40}
          id={integration.id}
          useSquareLogo
          integrationName={integration.integration_name}
          imgStyle={{ borderRadius: `${theme.attributes.borderRadius.secondary} !important` }}
        />
      ) : (
        <img
          src={getIntegrationLogoFromManifest(integration.integration_name, manifestData)}
          alt={`${integration.name} logo`}
          width="44px"
          height="44px"
        />
      )}

      <IntegrationTextItem active={!integration.deleted}>
        <InstanceTooltip
          title={
            <>
              <Box className="tooltip-wrapper">
                <ArrowUpTooltip />
                <Typography className="tooltip-text">{integration.name}</Typography>
              </Box>
            </>
          }
          sx={{
            [`& .${tooltipClasses.tooltip}`]: {
              width: 'fit-content !important'
            }
          }}
        >
          <Typography>{integration.is_v2 ? integration.name : integration.name}</Typography>
        </InstanceTooltip>

        <Box className="box-wrapper">
          <Typography className="text">{!integration.deleted ? 'Active' : 'Non active'}</Typography>
        </Box>
      </IntegrationTextItem>

      {integration.is_v2 && integration.instance_name ? (
        <Checkbox
          inputProps={{ 'aria-label': 'Checkbox' }}
          checked={checked[integration.instance_name]}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => changeHandler(e, integration)}
          icon={<InstanceUncheckedIcon />}
          checkedIcon={<InstanceCheckedIcon />}
        />
      ) : (
        <Checkbox
          inputProps={{ 'aria-label': 'Checkbox' }}
          checked={checked[integration.name]}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => changeHandler(e, integration)}
          icon={<InstanceUncheckedIcon />}
          checkedIcon={<InstanceCheckedIcon />}
        />
      )}
    </IntegrationInstanceCard>
  )
}

export default DataSourceCard
